import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';

export interface IPrintDialogState {
    visible: boolean;
}

export const printDialogSlice = createSlice({
    name: 'printDialog',
    initialState: {
        visible: false,
    } as IPrintDialogState,
    reducers: {
        update: (state, action: PayloadAction<boolean>) => {
            state.visible = action.payload;
        },
    },
});

export const { update } = printDialogSlice.actions;
export const printDialogVisibility = (state: IGlobalStoreReducers) => state.printDialog.visible;

export default printDialogSlice.reducer;
